import script from "./Room.vue?vue&type=script&setup=true&lang=js"
export * from "./Room.vue?vue&type=script&setup=true&lang=js"

import "./Room.vue?vue&type=style&index=0&id=be988c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be988c1c"]])

export default __exports__